import React from 'react';
import { getView } from '../../../utils/domUtils';
import { Connect, PropsFromRedux } from './SearchReplayContainer';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';

type Props = PropsFromRedux;

export class RawSearchReplay extends React.Component<Props> {
  componentDidMount() {
    window.addEventListener('popstate', this.onBrowserPopstate);
    window.addEventListener(
      'beforeunload',
      this.addOriginalQueryKeyToUrlForBrowserHistory,
    );
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBrowserPopstate);
    window.removeEventListener(
      'beforeunload',
      this.addOriginalQueryKeyToUrlForBrowserHistory,
    );
  }

  addOriginalQueryKeyToUrlForBrowserHistory = () => {
    const { originalQueryKey } = this.props;
    if (originalQueryKey) {
      const replacedUrl = buildUrlWithParameters(window.location.href, {
        original_query_key: originalQueryKey,
      });
      window.history.replaceState({}, '', replacedUrl);
    }
  };

  onBrowserPopstate = () => {
    const view = getView();
    if (view === 'search') {
      this.props.replaySearch(window.location.search);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  };

  render() {
    return null;
  }
}

export const SearchReplay = Connect(RawSearchReplay);
